import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs.tsx";
import { ListChecks, Users } from "lucide-react";
import { useCallback } from "react";
import { router } from "@/Router.tsx";
import { useRouterState } from "@tanstack/react-router";

export function TeamNavigationTabs() {
    const { location } = useRouterState();

    const getActiveTab = useCallback(() => {
        if (location.pathname.includes("/action-log")) return "action-log";
        return "members";
    }, [location.pathname]);

    const setActiveTab = (tab: string) => {
        const routes: Record<string, () => void> = {
            members: () => router.navigate({ to: "/team/members" }),
            "action-log": () => router.navigate({ to: "/team/action-log" }),
        };

        if (routes[tab]) {
            routes[tab]!();
        } else {
            router.navigate({ to: "/team/members" });
        }
    };

    return (
        <Tabs
            value={getActiveTab()}
            onValueChange={setActiveTab}
            className="h-auto mt-auto ml-auto lg:ml-0"
            activationMode="manual">
            <TabsList>
                <TabsTrigger
                    className="text-xl gap-2 uppercase"
                    value="members">
                    <Users className="size-5" />
                    <p className="hidden lg:block">Members</p>
                </TabsTrigger>
                <TabsTrigger
                    className="text-xl gap-2 uppercase"
                    value="action-log">
                    <ListChecks className="size-5" />
                    <p className="hidden lg:block">Action Log</p>
                </TabsTrigger>
            </TabsList>
        </Tabs>
    );
}
